/**
 * Public Realm-for-Host API client (TQ #9707/#9813). Unauthenticated — resolves
 * a Cockpit hostname to its Keycloak realm from organizations.custom_domain
 * instead of the hardcoded realmMap in main.tsx. Single source of truth so a
 * new tenant custom-domain doesn't require a frontend redeploy.
 *
 * Same convention as services/idpResolveApi.ts (public, no Bearer/JWT).
 */
import type { AxiosError } from 'axios'
import { createApiClient } from '../lib/apiClient'

// Same convention as services/api.ts: relative /api in prod (nginx proxy),



const client = createApiClient({
  timeout: 8000,
  headers: { 'Content-Type': 'application/json' },
})

export interface RealmForHostResponse {
  realm: string
}

export const RealmHostAPI = {
  /**
   * Resolve the Keycloak realm for a Cockpit hostname.
   * GET /api/public/realm-for-host?host=<hostname> -> { "realm": "<realm>" }
   * Throws if the host has no realm mapped (404) or the request fails —
   * callers fall back to the hardcoded realmMap (fail-safe, kein White-Screen).
   */
  async resolve(host: string): Promise<string> {
    try {
      const res = await client.get<RealmForHostResponse>(
        '/public/realm-for-host',
        { params: { host } }
      )
      const realm = res.data?.realm?.trim()
      if (!realm) {
        throw new Error('Leere Realm-Antwort')
      }
      return realm
    } catch (error) {
      const axiosError = error as AxiosError
      throw new Error(axiosError.message || 'Realm-Auflösung fehlgeschlagen')
    }
  },
}
